import { render } from "./TicketStep3.vue?vue&type=template&id=3ff555d4"
import script from "./TicketStep3.vue?vue&type=script&lang=js"
export * from "./TicketStep3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__